











































import Vue from 'vue';
import { Component, Mixins } from 'vue-property-decorator';
import LuxtagMixin from '@/assets/ts/luxtagMixin';
import LuxTagApi from '@/api';

@Component
export default class Home extends Mixins(LuxtagMixin) {
  public email: string = '';
  public password: string = '';
  public dictionary = {
        attributes: {
        // email: 'E-mail Address',
        // password: 'Password',
        // custom attributess
        },
        custom: {
            email: {
                required: () => 'Email can not be empty',
                // custom messages
            },
            password: {
                required: 'Password can not be empty',
                min: 'The password may not be lesser than 3 characters'
            }
        },
    };
  public showPassword = false;

  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      // access to component instance via `vm`
      vm.$store.commit('MUTATE_SHOW_NAVIGATION', false);
    });
  }

  public beforeRouteLeave(to: any, from: any, next: any) {
    next();
  }

  public mounted() {
    this.$validator.localize('en', this.dictionary);
  }

  public handleLogin() {
    this.$validator.validateAll().then((valid) => {
      // console.log(valid);
      // for UI purpose everything is true now
      // TODO: change true to valid
      if (valid) {
          // store auth
          // this.$store.commit('MUTATE_AUTH', {
          //   register: true,
          // });
          LuxTagApi.auth.login(this.email, this.password)
            .then((response) => {
              // console.log(response);
              // // redirect to home
              // this.$router.push('/event');
              this.$store.commit('MUTATE_AUTH_IS_LOGIN', true);
              this.$store.commit('MUTATE_AUTH_NAME', response.data.user.username);
              this.$store.commit('MUTATE_AUTH_EMAIL', response.data.user.email);
              this.$store.commit('MUTATE_AUTH_TOKEN', response.data.jwt);
              this.$router.push('/event');
            })
            .catch((err) => {
              // console.log('err: ', err);
              this.$notify({
                title: 'Login failed',
                type: 'error',
                text: err.response.data.message,
                duration: 4000,
              });
            });
      }
    });
  }
}
